import { Component, Input, OnChanges, OnInit } from '@angular/core';
import moment, { defaultFormatUtc } from 'moment';

@Component({
    selector: 'app-time-counter',
    templateUrl: './time-counter.component.html',
    styleUrls: ['./time-counter.component.scss']
})
export class TimeCounterComponent implements OnInit, OnChanges {
    @Input() timeString: string;
    @Input() timeType: string;

    isVisible: boolean;
    counter: number;
    counterOvertime: boolean;

    ngOnInit() {
        this.ngOnChanges();
    }

    ngOnChanges() {
        this.isVisible = this.checkIfVisible();
        this.counter = this.getCounter();
        this.counterOvertime = this.counter > 0;
    }

    checkIfVisible(): boolean {
        if (this.timeString === null || this.timeString === '' || this.timeType === null || this.timeType === '') {
            return false;
        }

        return true;
    }

    getCounter(): number {
        if (!this.checkIfVisible()) {
            return 0;
        }

        const time = moment(this.timeString);

        // Calculate difference in minutes
        return moment().diff(time, 'minutes') - 1;
    }

    getFormattedTime(): string {
        return moment(this.timeString, defaultFormatUtc).format('HH:mm');
    }
}
